import { useNavigate } from "react-router-dom";
import type { ReportDay } from "../lib/types";
import { formatDate, formatKes } from "../lib/format";

export function TrendChart({
  days,
  shopId,
  from,
  to,
}: {
  days: ReportDay[];
  shopId: string;
  from: string;
  to: string;
}) {
  const navigate = useNavigate();
  const shown = days.slice(-31);
  const max = shown.reduce(
    (value, day) => (day.totalSalesKes > value ? day.totalSalesKes : value),
    0n,
  );

  if (shown.length === 0) {
    return <div className="chart-empty">No sales were recorded in this period.</div>;
  }

  return (
    <div className="trend-chart" role="img" aria-label="Daily sales trend">
      {shown.map((day) => {
        const height = max === 0n ? 2 : Math.max(3, (Number(day.totalSalesKes) / Number(max)) * 100);
        return (
          <button
            type="button"
            className="trend-bar"
            key={day.date}
            title={`${formatDate(day.date, true)} · ${formatKes(day.totalSalesKes)}`}
            onClick={() =>
              navigate(
                `/shops/${shopId}/daily?from=${from}&to=${to}&day=${day.date}`,
              )
            }
          >
            <span style={{ height: `${height}%` }} />
            <small>{formatDate(day.date)}</small>
          </button>
        );
      })}
    </div>
  );
}
